import { createAction } from 'redux-act';

import { GenericPayload, RefreshTokenPayload, types } from './types';

export const refreshToken = createAction<RefreshTokenPayload>(types.REFRESH_TOKEN);
export const refreshTokenComplete = createAction(types.REFRESH_TOKEN_COMPLETE);
export const refreshTokenFail = createAction<any>(types.REFRESH_TOKEN_FAIL);
export const enqueueFailedAction = createAction<GenericPayload>(types.ENQUEUE_FAILED_ACTIONS);
export const dispatchQueuedActions = createAction(types.DISPATCH_QUEUED_ACTIONS);
